import React from 'react';

/**
 * MUI's Grid item xs/sm are column-spans out of 12; antd's Row/Col use a
 * 24-column grid. Doubling the span keeps every field the same visual width
 * it had before, without touching the field-config objects these SR forms
 * already pass around (xs/sm values stay expressed in the original 12-col terms).
 */
export const toAntdSpan = (muiSpan?: number): number | undefined =>
  typeof muiSpan === 'number' ? muiSpan * 2 : undefined;

export const fieldColProps = (field: any) => ({
  xs: toAntdSpan(field.xs) ?? 24,
  sm: toAntdSpan(field.sm),
  style: {
    padding: 8,
    display: field.isHidden ? 'none' : field.display,
  } as React.CSSProperties,
});

// Matches the mockup's field-label treatment (small, uppercase, letter-spaced,
// muted) used consistently elsewhere in the app (e.g. AdminDetailListItem) —
// a literal color rather than a theme token since this is a plain style object,
// not a component, so it can't call `theme.useToken()`. Light-mode-tuned like
// several other static style constants in this codebase.
export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  color: '#7C8898',
  marginBottom: 6,
};
